import React from 'react';
import { Router, Route, Link, browserHistory } from 'react-router'
import TopPanel from "../toppanel.js";

module.exports = React.createClass({
    componentDidMount: function () {
        HC_SubscribeHammerEvent(this.refs.panel, "swiperight", this.props.onGoBack);
    },
    componentWillUnmount: function () {
        HC_UnsubscribeHammerEvent(this.refs.panel, "swiperight");
    },
    
    copylinkHandle: function () {
        var copyTextarea = document.querySelector('#hc-link_id_input');
        copyTextarea.select();
        var successful = document.execCommand('copy');
    },

    goReportByLink: function (e) {
        if (window.cordova)
            this.props.onGoBack();
        else
            window.location = 'http://' + e.target.value;
    },

    render: function() {
        var report = HC_GetItemById(this.props.data, this.props.selectedId);
        var linkAddr = '/report/' + report.link;
        var fullLinkAddr = (window.HC_SERVER ? window.HC_SERVER : window.location.origin) + linkAddr;
        fullLinkAddr = fullLinkAddr.slice(fullLinkAddr.indexOf('//')+2);

        return (
            <div className="hc-internal-panel">
                <TopPanel text={HC_LANG.REP_SHARE_LINK} licon="fa-angle-left" onLiconClick={this.props.onGoBack}/>
                <div ref="panel" style={{position:"absolute", width:"100%", top:"60px", bottom:"0",overflowX:"hidden", overflowY:"auto", WebkitOverflowScrolling:'touch'}}>
                    <div className="hc-qr-div" style={{textAlign:'center', width:'100%', marginTop: '50px'}}>
                        <div className="hc-f3" style={{textAlign:'center', margin:'1rem'}}>{report.name}</div>

                        <input id="hc-link_id_input" className="copyable autoselect hc-f3 hc-green hc-text-with-cursor"
                               spellCheck="false" readOnly="true" value={fullLinkAddr}
                               style={{display:'block', textAlign:'center', margin: 'auto', marginBottom:'1rem', border: '0 transparent', width: '90%'}}
                               onClick={this.goReportByLink}/>

                        <button type='button' className='hc-button' style={{marginRight:'1rem'}}
                                onClick={this.copylinkHandle}>{HC_LANG.REP_COPY_LINK}</button>
                    </div>
                </div>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./reports/ShareLink.js